import { combineReducers } from 'redux';
import models, * as modelSelectors from './models';

const reducer = combineReducers({
    models
});

export default reducer;

export const getModelsData = state => modelSelectors.getModelsData(state.models);
export const getModelsError = state => modelSelectors.getModelsError(state.models);
export const getModelsIsLoading = state => modelSelectors.getModelsIsLoading(state.models);